import React, { useEffect, useState } from "react";
import axios from "axios";
import { Loader } from "react-overlay-loader";
import DatePicker from "react-datepicker";
import ReactTable from "react-table";
import moment from "moment/moment";
import XLSX from "xlsx-js-style";
import formatCurency from "../../../component/format/formatCurency";
import Select from "react-select";

const ReportDocMonitoringInternal = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [listBranch, setListBranch] = useState([]);
  const [listCustomer, setListCustomer] = useState([]);
  const [selectedInvoieBranch, setInvoiceBranch] = useState();
  const [selectedBranchTTF, setSelectedBranchTTF] = useState();
  const [selectedCustomer, setSelectedCustomer] = useState();
  const [selectedStartDate, setSelectedStartDate] = useState();
  const [selectedEndDate, setSelectedEndDate] = useState();
  const [listData, setListData] = useState([]);
  const [donwloadData, setDownloadData] = useState([]);

  useEffect(() => {
    getBranch();
  }, []);

  const getBranch = () => {
    setIsLoading(true);
    // let url = "https://api-digifin.dexagroup.com/collection/v1/master/lov/branch";
    let url = `${process.env.REACT_APP_COLLECTION_URL}/v1/master/lov/branch`;
    axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${process.env.REACT_APP_COLLECTION_TOKEN}`,
        "api-key": process.env.REACT_APP_COLLECTION_API_KEY,
      },
    })
      .then((response) => {
        setListBranch(response.data.data);
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  const customer = (string) => {
    setIsLoading(true);
    // let url = `https://api-digifin.dexagroup.com/collection/v1/master/lov/customer/all?org_id=${string}&customer_name=${""}`
    let url = `${
      process.env.REACT_APP_COLLECTION_URL
    }/v1/master/lov/customer/all?org_id=${string}&customer_name=${""}`;
    axios({
      method: "GET",
      url: url,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${process.env.REACT_APP_COLLECTION_TOKEN}`,
        "api-key": process.env.REACT_APP_COLLECTION_API_KEY,
      },
    })
      .then((response) => {
        const maping = response.data.data.map((value, index) => {
          return { value: value.CUSTOMER_ID, label: value.CUSTOMER_NAME };
        });
        setListCustomer(maping);
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setIsLoading(false);
      });
  };

  const search = () => {
    if (!validate()) {
      setIsLoading(true);
      const param = {
        CUSTOMER_ID: selectedCustomer.value,
        TTF_BRANCH: selectedBranchTTF,
        INV_BRANCH: selectedInvoieBranch,
        INV_START_DATE: selectedStartDate
          ? moment(selectedStartDate).format("YYYY-MM-DD")
          : null,
        INV_END_DATE: selectedEndDate
          ? moment(selectedEndDate).format("YYYY-MM-DD")
          : null,
      };
      // let url = 'https://api-digifin.dexagroup.com/collection/v1/report/monitoring-internal'
      let url = `${process.env.REACT_APP_COLLECTION_URL}/v1/report/monitoring-internal`;
      axios
        .post(url, param, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_COLLECTION_TOKEN}`,
            "api-key": process.env.REACT_APP_COLLECTION_API_KEY,
          },
        })
        .then((response) => {
          const res = response.data.data;
          const maping = res.map((value, index) => {
            return {
              CUSTOMER_ID: value.CUSTOMER_ID ? value.CUSTOMER_ID : "",
              TTF_BRANCH: value.TTF_BRANCH ? value.TTF_BRANCH : "",
              INV_BRANCH: value.INV_BRANCH ? value.INV_BRANCH : "",
              CUSTOMER_GROUP: value.CUSTOMER_GROUP ? value.CUSTOMER_GROUP : "",
              CUSTOMER_NAME: value.CUSTOMER_NAME ? value.CUSTOMER_NAME : "",
              NO_SO: value.NO_SO ? value.NO_SO : "",
              NO_DO: value.NO_DO ? value.NO_DO : "",
              NO_PO: value.NO_PO ? value.NO_PO : "",
              INV_NUMBER: value.INV_NUMBER ? value.INV_NUMBER : "",
              INV_DATE: value.INV_DATE
                ? moment(value.INV_DATE).format("DD MMMM YYYY")
                : value.INV_DATE,
              TOTAL_AMOUNT: value.TOTAL_AMOUNT ? value.TOTAL_AMOUNT : "",
              FAKTUR_PAJAK: value.FAKTUR_PAJAK ? value.FAKTUR_PAJAK : "",
              DOC_FLAG_INV: value.DOC_FLAG_INV ? value.DOC_FLAG_INV : "",
              DOC_FLAG_FP: value.DOC_FLAG_FP ? value.DOC_FLAG_FP : "",
              DOC_FLAG_KWITANSI: value.DOC_FLAG_KWITANSI
                ? value.DOC_FLAG_KWITANSI
                : "",
              DOC_FLAG_RECEIVING: value.DOC_FLAG_RECEIVING
                ? value.DOC_FLAG_RECEIVING
                : "",
              DOC_FLAG_DO: value.DOC_FLAG_DO ? value.DOC_FLAG_DO : "",
              DOC_FLAG_PO: value.DOC_FLAG_PO ? value.DOC_FLAG_PO : "",
              DOC_STATUS: value.DOC_STATUS ? value.DOC_STATUS : "",
              SCANNED_BY: value.SCANNED_BY ? value.SCANNED_BY : "",
              SCANNED_DATE: value.SCANNED_DATE
                ? moment(value.SCANNED_DATE).format("DD MMMM YYYY")
                : value.SCANNED_DATE,
              DESTINATION: value.DESTINATION ? value.DESTINATION : "",
              RECEIPT_DOC_MONITORING_DATE: value.RECEIPT_DOC_MONITORING_DATE
                ? value.RECEIPT_DOC_MONITORING_DATE
                : "",
              GENERATE_TTF_DATE: value.GENERATE_TTF_DATE
                ? moment(value.GENERATE_TTF_DATE).format("DD MMMM YYYY")
                : "",
            };
          });

          const show = res.map((value, index) => {
            return {
              CUSTOMER_ID: value.CUSTOMER_ID ? value.CUSTOMER_ID : "",
              TTF_BRANCH: value.TTF_BRANCH ? value.TTF_BRANCH : "",
              INV_BRANCH: value.INV_BRANCH ? value.INV_BRANCH : "",
              CUSTOMER_GROUP: value.CUSTOMER_GROUP ? value.CUSTOMER_GROUP : "",
              CUSTOMER_NAME: value.CUSTOMER_NAME ? value.CUSTOMER_NAME : "",
              NO_SO: value.NO_SO ? value.NO_SO : "",
              NO_DO: value.NO_DO ? value.NO_DO : "",
              NO_PO: value.NO_PO ? value.NO_PO : "",
              INV_NUMBER: value.INV_NUMBER ? value.INV_NUMBER : "",
              INV_DATE: value.INV_DATE
                ? moment(value.INV_DATE).format("DD MMMM YYYY")
                : value.INV_DATE,
              TOTAL_AMOUNT: value.TOTAL_AMOUNT
                ? formatCurency(value.TOTAL_AMOUNT)
                : "",
              FAKTUR_PAJAK: value.FAKTUR_PAJAK ? value.FAKTUR_PAJAK : "",
              DOC_FLAG_INV: value.DOC_FLAG_INV ? value.DOC_FLAG_INV : "",
              DOC_FLAG_FP: value.DOC_FLAG_FP ? value.DOC_FLAG_FP : "",
              DOC_FLAG_KWITANSI: value.DOC_FLAG_KWITANSI
                ? value.DOC_FLAG_KWITANSI
                : "",
              DOC_FLAG_RECEIVING: value.DOC_FLAG_RECEIVING
                ? value.DOC_FLAG_RECEIVING
                : "",
              DOC_FLAG_DO: value.DOC_FLAG_DO ? value.DOC_FLAG_DO : "",
              DOC_FLAG_PO: value.DOC_FLAG_PO ? value.DOC_FLAG_PO : "",
              DOC_STATUS: value.DOC_STATUS ? value.DOC_STATUS : "",
              SCANNED_BY: value.SCANNED_BY ? value.SCANNED_BY : "",
              SCANNED_DATE: value.SCANNED_DATE
                ? moment(value.SCANNED_DATE).format("DD MMMM YYYY")
                : value.SCANNED_DATE,
              DESTINATION: value.DESTINATION ? value.DESTINATION : "",
              RECEIPT_DOC_MONITORING_DATE: value.RECEIPT_DOC_MONITORING_DATE
                ? value.RECEIPT_DOC_MONITORING_DATE
                : "",
              GENERATE_TTF_DATE: value.GENERATE_TTF_DATE
                ? moment(value.GENERATE_TTF_DATE).format("DD MMMM YYYY")
                : "",
            };
          });
          setListData(show);
          setDownloadData(maping);
          setIsLoading(false);
        })
        .catch((e) => {
          setIsLoading(false);
        });
    }
  };

  const validate = () => {
    let valid = false;

    var a = moment(selectedStartDate);
    var b = moment(selectedEndDate);
    var c = moment.duration(b.diff(a)).asDays();
    if (!selectedInvoieBranch) {
      valid = true;
      alert("Please select Invoice Branch");
    } else if (!selectedCustomer) {
      valid = true;
      alert("Please select Customer Name");
    } else if (!selectedStartDate) {
      valid = true;
      alert("Please select Start Date");
    } else if (!selectedEndDate) {
      valid = true;
      alert("Please select End Date");
    } else if (c > 13) {
      valid = true;
      alert("Maximum length of the date range 2 week");
    }

    return valid;
  };
  const renderTable = () => {
    const column = [];
    if (listData.length) {
      Object.keys(listData[0]).forEach((e) => {
        column.push({
          Header: e.toUpperCase().replace(/_/g, " "),
          accessor: e.toString(),
          filterable: true,
        });
      });
    }

    const data = {
      columns: column,
      rows: listData,
    };
    return (
      <div className="row">
        <div className="col-12 text-right">
          <div className="col-12 mt-2 px-0">
            <ReactTable
              style={{ minHeight: "500px", marginTop: "30px" }}
              className="fullWidth"
              data={data.rows}
              columns={data.columns}
              defaultPageSize={10}
              defaultFilterMethod={(filter, row, column) => {
                let columnes = row[filter.id];
                return columnes
                  ? columnes.toLowerCase().includes(filter.value.toLowerCase())
                  : "";
              }}
            />
          </div>
        </div>
      </div>
    );
  };

  const download = () => {
    const wb = XLSX.utils.book_new();

    let row1 = [];
    let row2 = [
      "Customer ID",
      "TTF branch",
      "Invoice Branch",
      "Customer Group",
      "Customer Name",
      "No SO",
      "No DO",
      "No PO",
      "Invoice Number",
      "Invoice Date",
      "TOTAL AMOUNT",
      "Faktur Pajak",
      "Document Flag",
      "",
      "",
      "",
      "",
      "",
      "Status Document",
      "Scanned By",
      "Scanned Date",
      "Destination",
      "Receipt Document Monitoring Date",
      "Generate TTF Date",
    ];
    let row3 = [
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "10",
      "11",
      "12",
      "INV",
      "FP",
      "KUITANSI",
      "RECEIVING",
      "PO",
      "DO",
      "",
      "",
      "",
      "",
      "",
      "",
    ];

    let mapingRow2 = row2.map((value, index) => {
      return {
        v: value,
        t: "s",
        s: {
          font: {
            bold: true,
            sz: 12,
          },
          alignment: {
            vertical: "center",
            horizontal: "center",
            wrapText: true,
          },
          fill: {
            fgColor: { rgb: "97f8ff" },
          },
          border: {
            right: {
              style: "thin",
              color: "000000",
            },
            left: {
              style: "thin",
              color: "000000",
            },
            top: {
              style: "thin",
              color: "000000",
            },
            bottom: {
              style: "thin",
              color: "000000",
            },
          },
        },
      };
    });

    let mapingRow3 = row3.map((value, index) => {
      return {
        v: value,
        t: "s",
        s: {
          font: {
            bold: true,
          },
          alignment: {
            vertical: "center",
            horizontal: "center",
          },
          fill: {
            fgColor: { rgb: "97f8ff" },
          },
          border: {
            right: {
              style: "thin",
              color: "000000",
            },
            left: {
              style: "thin",
              color: "000000",
            },
            top: {
              style: "thin",
              color: "000000",
            },
            bottom: {
              style: "thin",
              color: "000000",
            },
          },
        },
      };
    });
    const manipulateArray = donwloadData.map((value, index) => {
      return [
        value.CUSTOMER_ID ? value.CUSTOMER_ID : "",
        value.TTF_BRANCH ? value.TTF_BRANCH : "",
        value.INV_BRANCH ? value.INV_BRANCH : "",
        value.CUSTOMER_GROUP ? value.CUSTOMER_GROUP : "",
        value.CUSTOMER_NAME ? value.CUSTOMER_NAME : "",
        value.NO_SO ? value.NO_SO : "",
        value.NO_DO ? value.NO_DO : "",
        value.NO_PO ? value.NO_PO : "",
        value.INV_NUMBER ? value.INV_NUMBER : "",
        value.INV_DATE ? value.INV_DATE : "",
        value.TOTAL_AMOUNT ? value.TOTAL_AMOUNT : "",
        value.FAKTUR_PAJAK ? value.FAKTUR_PAJAK : "",
        value.DOC_FLAG_INV ? value.DOC_FLAG_INV : "",
        value.DOC_FLAG_FP ? value.DOC_FLAG_FP : "",
        value.DOC_FLAG_KWITANSI ? value.DOC_FLAG_KWITANSI : "",
        value.DOC_FLAG_RECEIVING ? value.DOC_FLAG_RECEIVING : "",
        value.DOC_FLAG_PO ? value.DOC_FLAG_PO : "",
        value.DOC_FLAG_DO ? value.DOC_FLAG_DO : "",
        value.DOC_STATUS ? value.DOC_STATUS : "",
        value.SCANNED_BY ? value.SCANNED_BY : "",
        value.SCANNED_DATE ? value.SCANNED_DATE : "",
        value.DESTINATION ? value.DESTINATION : "",
        value.RECEIPT_DOC_MONITORING_DATE
          ? value.RECEIPT_DOC_MONITORING_DATE
          : "",
        value.GENERATE_TTF_DATE ? value.GENERATE_TTF_DATE : "",
      ];
    });

    const mapingRow4 = manipulateArray.map((value) => {
      return value.map((i) => {
        return {
          v: i,
          t: "s",
          s: {
            border: {
              right: {
                style: "thin",
                color: "000000",
              },
              left: {
                style: "thin",
                color: "000000",
              },
              top: {
                style: "thin",
                color: "000000",
              },
              bottom: {
                style: "thin",
                color: "000000",
              },
            },
          },
        };
      });
    });

    const merge2 = [
      { s: { c: 0, r: 1 }, e: { c: 0, r: 2 } },
      { s: { c: 1, r: 1 }, e: { c: 1, r: 2 } },
      { s: { c: 2, r: 1 }, e: { c: 2, r: 2 } },
      { s: { c: 3, r: 1 }, e: { c: 3, r: 2 } },
      { s: { c: 4, r: 1 }, e: { c: 4, r: 2 } },
      { s: { c: 5, r: 1 }, e: { c: 5, r: 2 } },
      { s: { c: 6, r: 1 }, e: { c: 6, r: 2 } },
      { s: { c: 7, r: 1 }, e: { c: 7, r: 2 } },
      { s: { c: 8, r: 1 }, e: { c: 8, r: 2 } },
      { s: { c: 9, r: 1 }, e: { c: 9, r: 2 } },
      { s: { c: 10, r: 1 }, e: { c: 10, r: 2 } },
      { s: { c: 11, r: 1 }, e: { c: 11, r: 2 } },
      { s: { c: 12, r: 1 }, e: { c: 17, r: 1 } }, //Doc Flag Adm Ink (posisi doc terakhir scan)
      { s: { c: 18, r: 1 }, e: { c: 18, r: 2 } },
      { s: { c: 19, r: 1 }, e: { c: 19, r: 2 } },
      { s: { c: 20, r: 1 }, e: { c: 20, r: 2 } },
      { s: { c: 21, r: 1 }, e: { c: 21, r: 2 } },
      { s: { c: 22, r: 1 }, e: { c: 22, r: 2 } },
      { s: { c: 23, r: 1 }, e: { c: 23, r: 2 } },
    ];

    // var merge = XLSX.utils.decode_range("U2:U3"); // this is equivalent
    const ws = XLSX.utils.aoa_to_sheet(
      [row1, mapingRow2, mapingRow3].concat(mapingRow4)
    );
    XLSX.utils.decode_range(ws["!ref"]);
    ws["!cols"] = row3.map((value) => {
      return {
        width: 30,
      };
    });
    ws["!rows"] = row3.map((value) => {
      return {
        height: 30,
      };
    });
    ws["!merges"] = merge2;
    XLSX.utils.book_append_sheet(wb, ws, `Report Monitoring Internal`);

    XLSX.writeFile(
      wb,
      `Report Monitoring Internal ${moment(new Date()).format(
        "DD-MMM-YYYY"
      )}.xlsx`
    );
  };

  return (
    <div>
      <section className="content">
        <div className="container-fluid">
          <div className="row ml-1">
            <div className="col-lg-12 col-sx-12">
              <div className="card card-info">
                <div className="card-header">
                  Report Document Monitoring Internal
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-3">
                            <label>Invoice Branch</label>
                            <select
                              className="form-control"
                              name="orgSource"
                              onChange={(e) => {
                                const splitBranch = e.target.value.split("/");
                                setListCustomer([]);
                                setSelectedCustomer(null);
                                setInvoiceBranch(splitBranch[0]);
                                customer(splitBranch[1]);
                              }}
                            >
                              <option value={0}>No Selected Branch</option>
                              {listBranch.length
                                ? listBranch.map((item, index) => (
                                    <option
                                      value={
                                        item.BRANCH_CODE + "/" + item.ORG_ID
                                      }
                                      key={index}
                                    >
                                      {item.BRANCH_CODE}
                                    </option>
                                  ))
                                : null}
                            </select>
                          </div>
                          <div className="col-md-3">
                            <label>Customer Name</label>
                            <Select
                              defaultValue={selectedCustomer}
                              onChange={setSelectedCustomer}
                              options={listCustomer}
                            />
                          </div>
                          <div className="col-md-3">
                            <div className="">
                              <label>Invoice Date (From)</label>
                              <div className="customDatePickerWidth">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={selectedStartDate}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control myDatePicker"
                                  popperPlacement="bottom-end"
                                  onChange={(e) => setSelectedStartDate(e)}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <div className="">
                              <label>
                                Invoice Date (To){" "}
                                <span
                                  style={{ fontSize: "11px", color: "red" }}
                                >
                                  (Max 2 week)
                                </span>
                              </label>
                              <div className="customDatePickerWidth">
                                <DatePicker
                                  placeholder="Submitted Date from"
                                  selected={selectedEndDate}
                                  dateFormat="d-MMM-yyyy"
                                  className="form-control myDatePicker"
                                  popperPlacement="bottom-end"
                                  onChange={(e) => setSelectedEndDate(e)}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-3">
                            <label>TTF Branch</label>
                            <select
                              className="form-control"
                              name="orgName"
                              onChange={(e) => setSelectedBranchTTF(e)}
                            >
                              <option value={0}>ALL</option>
                              {listBranch.length
                                ? listBranch.map((item, index) => (
                                    <option value={item.org_name} key={index}>
                                      {item.org_name}
                                    </option>
                                  ))
                                : null}
                            </select>
                          </div>
                          <div className="col-md-3">
                            <div className="">
                              <label>&nbsp;</label>
                              <button
                                className="btn btn-primary btn-block"
                                onClick={() => search()}
                              >
                                <i className="fa fa-search"></i> Search
                              </button>
                            </div>
                          </div>
                          <div className="col-md-3">
                            <label>&nbsp;</label>
                            <button
                              disabled={!listData.length ? true : false}
                              className="btn btn-success btn-block"
                              onClick={() => download()}
                            >
                              <i className="fa fa-file-excel"></i> Export
                            </button>
                          </div>
                        </div>
                        <div className="row mt-2">
                          <div className="col-md-12">{renderTable()}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Loader fullPage loading={isLoading} />
    </div>
  );
};

export default ReportDocMonitoringInternal;
